module.exports = "../assets/yachtfull-logo-blue-bg-no-brands.062190a9.svg";